import { render, staticRenderFns } from "./AnswerDetails.vue?vue&type=template&id=25058b64"
import script from "./AnswerDetails.vue?vue&type=script&lang=js"
export * from "./AnswerDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports